import List from './List'

const carsBattResource = {
  list: List,
}

export default carsBattResource
